webpackJsonp([91],{

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_reset_password_vue__ = __webpack_require__(2259);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1a9af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_reset_password_vue__ = __webpack_require__(3418);
function injectStyle (ssrContext) {
  __webpack_require__(3416)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13c1a9af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_reset_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1a9af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var signin = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var userData, url, text, _text;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoading = true;
						userData = {};
						url = !this.send && !this.tokenPassword ? 'password/email' : 'password/reset';

						if (!this.send && !this.tokenPassword) {
							userData.email = this.user;
							userData.codeApp = 'praktiko-admin';
						} else {
							userData.password = this.password;
							userData.token = this.tokenPassword;
						}
						_context.prev = 4;
						_context.next = 7;
						return this.$httpPraktiko.post('external-api/' + url, userData);

					case 7:
						if (!this.send) {
							this.send = true;
						}
						text = !this.tokenPassword ? 'Correo enviado correctamente.' : 'Contraseña cambiada correctamente.';

						this.$store.dispatch('showSnackBar', { text: text, color: 'success' });
						if (this.tokenPassword) {
							this.goTo('login');
						}
						_context.next = 18;
						break;

					case 13:
						_context.prev = 13;
						_context.t0 = _context['catch'](4);
						_text = '';

						if (_context.t0.status === 500) {
							_text = 'Error del servidor';
						} else if (_context.t0.status === 400) {
							if (this.tokenPassword) {
								_text = 'El token es inválido o ya ha caducado.';
							} else if (_context.t0.data.message === 'CUSTOMER_NOT_FOUND') {
								_text = 'Usuario incorrecto';
							} else if (_context.t0.data.error === 'Method Not Allowed') {
								_text = 'No se ha encontrado el usuario';
							}
						} else if (_context.t0.status === 401) {
							if (_context.t0.data.message === 'TOKEN_HAS_EXPIRED') {
								_text = 'El token ha caducado.';
							} else if (this.tokenPassword) {
								_text = 'El token es inválido';
							}
						}
						this.$store.dispatch('showSnackBar', { text: _text, color: 'error' });

					case 18:
						_context.prev = 18;

						this.isLoading = false;
						return _context.finish(18);

					case 21:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 13, 18, 21]]);
	}));

	return function signin() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	this.tokenPassword = this.$route.query.token;
	if (this.tokenPassword) {
		this.send = true;
	}
}

function loginLogo() {
	return 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktico-login.png';
}

function data() {
	return {
		companyBgUrl: '/static/img/login/background-praktiko.jpg',
		companyLoginLogo: Object({"NODE_ENV":"production","APP_CODE":'praktiko-admin',"APP_NAME":'"praktiko"',"PRAKTIKO_URL":'https://temp-praktiko.apprunn.net/',"MOCK_URL":'undefined',"ACL_URL":'https://temp-acl-praktiko.apprunn.net/api',"STORAGE_USER_KEY":"praktiko","S3_IMAGES_URL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos',"COMPANY_LOGIN_TITLE":'Praktiko',"POLL_ENGINE":'https://temp-pollengine.apprunn.net/',"UPLOAD_URL":'undefined',"COMPANY_LOGO_SMALL":'undefined',"COMPANY_LOGO":'undefined',"COLORS":'{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}',"LOGO_LOGIN":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktico-login.png',"LOGO_SMALL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-small.png',"LOGO":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktiko-slider.png',"CREDENTIAL_SCRAPER":'http://34.204.114.234:8080/'}).COMPANY_LOGIN_LOGO,
		isLoading: false,
		password: '',
		repeatPassword: '',
		showPass: false,
		user: '',
		tokenPassword: '',
		send: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reset-password',
	computed: {
		loginLogo: loginLogo
	},
	created: created,
	data: data,
	methods: {
		signin: signin
	}
});

/***/ }),

/***/ 3416:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("192ba43e", content, true, {});

/***/ }),

/***/ 3417:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.text-password[data-v-13c1a9af]{border-style:none;font-family:NeuzeitGroT;font-size:14px;margin-top:20.5px;text-align:center;text-decoration:none!important}a[data-v-13c1a9af]{text-decoration:none!important}.login-subtitle[data-v-13c1a9af]{color:#545a54;font-family:NeuzeitGroT;font-size:19px;margin-bottom:25px}.login-subtitle span[data-v-13c1a9af]{font-family:NeuzeitGroTBold}.login-caption[data-v-13c1a9af]{color:#aeaeae;font-size:13px}.main-login[data-v-13c1a9af]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around;background-position:50%;background-repeat:no-repeat;background-size:cover;height:100vh}.main-login .login[data-v-13c1a9af]{left:150px;position:absolute;text-align:center;width:315px;z-index:5}.main-login .login .login-logo[data-v-13c1a9af]{margin-bottom:50px}.main-login .login .login-header[data-v-13c1a9af]{color:#fff;margin:0 auto 54px;width:314px}.main-login .login .login-inputs[data-v-13c1a9af]{font-size:24px;margin-bottom:30px;position:relative;width:100%}.main-login .login .login-inputs .login-inputs-txt[data-v-13c1a9af]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-13c1a9af]{width:90%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-13c1a9af]{color:#fff;height:60px;outline:none;width:100%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-13c1a9af]{font-size:12px;float:left}.main-login .login .login-inputs .login-spacer[data-v-13c1a9af]{border:1px solid;opacity:.7;width:100%}.main-login .login .login-footer[data-v-13c1a9af]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around}.main-login .login .login-footer .login-btn[data-v-13c1a9af]{border-radius:100px;color:#fff!important;height:48px;line-height:48px;margin:auto;text-align:center;width:280px;font-family:NeuzeitGroT;font-size:18px;margin-bottom:22px;outline:none;text-transform:none!important}.main-login .login .login-footer .login-btn[data-v-13c1a9af]:active{-webkit-transform:scale(.9);transform:scale(.9);font-size:18px!important}.main-login .login .login-footer .disabled[data-v-13c1a9af]{background-color:#fff;border-radius:100px;color:#37abd0!important;height:48px;line-height:48px;margin:auto;text-align:center;width:280px}.main-login .login-info .login-info-text[data-v-13c1a9af]{color:#fff;margin-bottom:30px}.main-login .login-info .login-info-btn[data-v-13c1a9af]{border-radius:5px;color:#fff!important;font-size:16px;height:45px;line-height:45px;margin:auto;text-align:center;width:127px;cursor:pointer;display:block;text-decoration:none!important}.main-login .login-info .login-info-btn[data-v-13c1a9af]:active{-webkit-transform:scale(.9);transform:scale(.9)}@-webkit-keyframes autofill-data-v-13c1a9af{to{color:#fff;background:transparent}}@keyframes autofill-data-v-13c1a9af{to{color:#fff;background:transparent}}input[data-v-13c1a9af]:-webkit-autofill{-webkit-animation-name:autofill-data-v-13c1a9af;animation-name:autofill-data-v-13c1a9af;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:transparent!important}.background-opacity[data-v-13c1a9af]{background-image:linear-gradient(280deg,hsla(0,0%,100%,.41),hsla(0,0%,100%,.96) 76%,hsla(0,0%,100%,.96));bottom:0;left:0;position:absolute;right:0;top:0}.icon-eyes[data-v-13c1a9af]{position:absolute;top:70px;right:20px}.message-send[data-v-13c1a9af]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f9f9f9;border:1px solid #ababab;border-radius:4px;color:#545a54;display:-webkit-box;display:-ms-flexbox;display:flex;font-family:NeuzeitGroTLig;font-size:14px;height:103px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:normal;padding:0 30px;width:316px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-reset-password.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,gCACE,kBAAmB,AACnB,wBAA2B,AAC3B,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,8BAAiC,CAClC,AACD,mBACE,8BAAiC,CAClC,AACD,iCACE,cAAe,AACf,wBAA2B,AAC3B,eAAgB,AAChB,kBAAoB,CACrB,AACD,sCACI,2BAA+B,CAClC,AACD,gCACE,cAAe,AACf,cAAgB,CACjB,AACD,6BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,6BAA8B,AAClC,wBAA4B,AAC5B,4BAA6B,AAC7B,sBAAuB,AACvB,YAAc,CACf,AACD,oCACI,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,YAAa,AACb,SAAW,CACd,AACD,gDACM,kBAAoB,CACzB,AACD,kDACM,WAAe,AACf,mBAAoB,AACpB,WAAa,CAClB,AACD,kDACM,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CACjB,AACD,oEACQ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC9C,AACD,wFACU,SAAW,CACpB,AACD,qGACY,WAAe,AACf,YAAa,AACb,aAAc,AACd,UAAY,CACvB,AACD,6GACY,eAAgB,AAChB,UAAY,CACvB,AACD,gEACQ,iBAAkB,AAClB,WAAa,AACb,UAAY,CACnB,AACD,kDACM,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,4BAA8B,CACvC,AACD,6DACQ,oBAAqB,AACrB,qBAAwB,AACxB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,wBAA2B,AAC3B,eAAgB,AAChB,mBAAoB,AACpB,aAAc,AACd,6BAAgC,CACvC,AACD,oEACQ,4BAA8B,AACtB,oBAAsB,AAC9B,wBAA2B,CAClC,AACD,4DACQ,sBAA0B,AAC1B,oBAAqB,AACrB,wBAA0B,AAC1B,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,WAAa,CACpB,AACD,0DACI,WAAe,AACf,kBAAoB,CACvB,AACD,yDACI,kBAAmB,AACnB,qBAAwB,AACxB,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,8BAAiC,CACpC,AACD,gEACI,4BAA8B,AACtB,mBAAsB,CACjC,AACD,4CACA,GACI,WAAa,AACb,sBAAwB,CAC3B,CACA,AACD,oCACA,GACI,WAAa,AACb,sBAAwB,CAC3B,CACA,AACD,wCACE,gDAAiD,AACzC,wCAAyC,AACjD,iCAAkC,AAC1B,yBAA0B,AAClC,sCAAyC,CAC1C,AACD,qCACE,yGAA+H,AAC/H,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AACD,4BACE,kBAAmB,AACnB,SAAU,AACV,UAAY,CACb,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA8B,AAC9B,eAAgB,AAChB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AACpB,eAAkB,AAClB,WAAa,CACd","file":"page-reset-password.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.text-password[data-v-13c1a9af] {\n  border-style: none;\n  font-family: \"NeuzeitGroT\";\n  font-size: 14px;\n  margin-top: 20.5px;\n  text-align: center;\n  text-decoration: none !important;\n}\na[data-v-13c1a9af] {\n  text-decoration: none !important;\n}\n.login-subtitle[data-v-13c1a9af] {\n  color: #545a54;\n  font-family: \"NeuzeitGroT\";\n  font-size: 19px;\n  margin-bottom: 25px;\n}\n.login-subtitle span[data-v-13c1a9af] {\n    font-family: \"NeuzeitGroTBold\";\n}\n.login-caption[data-v-13c1a9af] {\n  color: #aeaeae;\n  font-size: 13px;\n}\n.main-login[data-v-13c1a9af] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n}\n.main-login .login[data-v-13c1a9af] {\n    left: 150px;\n    position: absolute;\n    text-align: center;\n    width: 315px;\n    z-index: 5;\n}\n.main-login .login .login-logo[data-v-13c1a9af] {\n      margin-bottom: 50px;\n}\n.main-login .login .login-header[data-v-13c1a9af] {\n      color: #ffffff;\n      margin: 0 auto 54px;\n      width: 314px;\n}\n.main-login .login .login-inputs[data-v-13c1a9af] {\n      font-size: 24px;\n      margin-bottom: 30px;\n      position: relative;\n      width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt[data-v-13c1a9af] {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-13c1a9af] {\n          width: 90%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-13c1a9af] {\n            color: #ffffff;\n            height: 60px;\n            outline: none;\n            width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-13c1a9af] {\n            font-size: 12px;\n            float: left;\n}\n.main-login .login .login-inputs .login-spacer[data-v-13c1a9af] {\n        border: 1px solid;\n        opacity: 0.7;\n        width: 100%;\n}\n.main-login .login .login-footer[data-v-13c1a9af] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -ms-flex-pack: distribute;\n          justify-content: space-around;\n}\n.main-login .login .login-footer .login-btn[data-v-13c1a9af] {\n        border-radius: 100px;\n        color: white !important;\n        height: 48px;\n        line-height: 48px;\n        margin: auto;\n        text-align: center;\n        width: 280px;\n        font-family: \"NeuzeitGroT\";\n        font-size: 18px;\n        margin-bottom: 22px;\n        outline: none;\n        text-transform: none !important;\n}\n.main-login .login .login-footer .login-btn[data-v-13c1a9af]:active {\n        -webkit-transform: scale(0.9);\n                transform: scale(0.9);\n        font-size: 18px !important;\n}\n.main-login .login .login-footer .disabled[data-v-13c1a9af] {\n        background-color: #ffffff;\n        border-radius: 100px;\n        color: #37abd0 !important;\n        height: 48px;\n        line-height: 48px;\n        margin: auto;\n        text-align: center;\n        width: 280px;\n}\n.main-login .login-info .login-info-text[data-v-13c1a9af] {\n    color: #ffffff;\n    margin-bottom: 30px;\n}\n.main-login .login-info .login-info-btn[data-v-13c1a9af] {\n    border-radius: 5px;\n    color: white !important;\n    font-size: 16px;\n    height: 45px;\n    line-height: 45px;\n    margin: auto;\n    text-align: center;\n    width: 127px;\n    cursor: pointer;\n    display: block;\n    text-decoration: none !important;\n}\n.main-login .login-info .login-info-btn[data-v-13c1a9af]:active {\n    -webkit-transform: scale(0.9);\n            transform: scale(0.9);\n}\n@-webkit-keyframes autofill-data-v-13c1a9af {\nto {\n    color: white;\n    background: transparent;\n}\n}\n@keyframes autofill-data-v-13c1a9af {\nto {\n    color: white;\n    background: transparent;\n}\n}\ninput[data-v-13c1a9af]:-webkit-autofill {\n  -webkit-animation-name: autofill-data-v-13c1a9af;\n          animation-name: autofill-data-v-13c1a9af;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  background-color: transparent !important;\n}\n.background-opacity[data-v-13c1a9af] {\n  background-image: linear-gradient(280deg, rgba(255, 255, 255, 0.41), rgba(255, 255, 255, 0.96) 76%, rgba(255, 255, 255, 0.96));\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.icon-eyes[data-v-13c1a9af] {\n  position: absolute;\n  top: 70px;\n  right: 20px;\n}\n.message-send[data-v-13c1a9af] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #f9f9f9;\n  border: 1px solid #ababab;\n  border-radius: 4px;\n  color: #545a54;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: \"NeuzeitGroTLig\";\n  font-size: 14px;\n  height: 103px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  line-height: normal;\n  padding: 0px 30px;\n  width: 316px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-login',[_c('div',{staticClass:"main-login",style:(("background-image: url(" + _vm.companyBgUrl + ")"))},[_c('div',{staticClass:"background-opacity"}),_vm._v(" "),_c('section',{staticClass:"login"},[_c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":_vm.loginLogo,"alt":"praktiko logo","height":"131","width":"345"}})]),_vm._v(" "),(!_vm.send)?_c('div',{staticClass:"login-subtitle"},[(!_vm.tokenPassword)?_c('p',{staticClass:"ma-0"},[_vm._v("¿No puedes ingresar a tu cuenta?")]):_vm._e(),_vm._v(" "),_c('span',{style:(("color:" + (_vm.$appColors.primary)))},[_vm._v("RESTABLECE TU CONTRASEÑA")])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"login-inputs",attrs:{"id":"login-form"},on:{"submit":function($event){$event.preventDefault();return _vm.signin($event)}}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":""}},[(!_vm.send && !_vm.tokenPassword)?_c('v-flex',{attrs:{"xs12":"","text-xs-left":""}},[_c('span',{staticClass:"caption login-caption"},[_vm._v("\n\t\t\t\t\t\t\tCorreo Electrónico\n\t\t\t\t\t\t")]),_vm._v(" "),_c('v-text-field',{staticClass:"login-input",attrs:{"autocomplete":"off","background-color":"transparent","box":"","color":"success","height":48,"hide-details":"","placeholder":"Email/Usuario","type":"email"},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1):(!_vm.tokenPassword)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"message-send"},[_vm._v("\n\t\t\t\t\t\t\tHemos enviado un enlace a tu correo\n\t\t\t\t\t\t\telectrónico para restablecer tu contraseña\n\t\t\t\t\t\t")])]):[_c('v-flex',{attrs:{"xs12":"","text-xs-left":""}},[_c('span',{staticClass:"caption login-caption"},[_vm._v("\n\t\t\t\t\t\t\t\tNueva Contraseña\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-text-field',{staticClass:"login-input",attrs:{"box":"","autocomplete":"off","background-color":"transparent","hide-details":"","placeholder":"Contraseña","append-icon":_vm.showPass ? 'visibility' : 'visibility_off',"type":_vm.showPass ? 'text' : 'password',"height":48},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-left":""}},[_c('span',{staticClass:"caption login-caption"},[_vm._v("\n\t\t\t\t\t\t\t\tRepetir Nueva Contraseña\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-text-field',{staticClass:"login-input",attrs:{"box":"","autocomplete":"off","background-color":"transparent","hide-details":"","placeholder":"Contraseña","append-icon":_vm.showPass ? 'visibility' : 'visibility_off',"type":_vm.showPass ? 'text' : 'password',"height":48},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},model:{value:(_vm.repeatPassword),callback:function ($$v) {_vm.repeatPassword=$$v},expression:"repeatPassword"}}),_vm._v(" "),(_vm.repeatPassword !== _vm.password)?_c('span',{staticClass:"caption",style:(("color:" + (_vm.$appColors.error)))},[_vm._v("\n\t\t\t\t\t\t\t\tLas contraseñas no coinciden\n\t\t\t\t\t\t\t")]):_vm._e()],1)]],2)],1),_vm._v(" "),(!_vm.send || _vm.tokenPassword)?_c('div',{staticClass:"login-footer"},[_c('v-btn',{staticClass:"login-btn",class:{ disabled: _vm.isLoading },style:(("background-color:" + (_vm.$appColors.primary))),attrs:{"accesskey":"13","disabled":_vm.isLoading || (_vm.send && (!_vm.password && !_vm.repeatPassword)) || _vm.repeatPassword !== _vm.password || (!_vm.send && !_vm.user),"form":"login-form","loading":_vm.isLoading,"type":"submit"}},[(!_vm.tokenPassword)?[_vm._v("\n\t\t\t\t\t\tReestablecer Contraseña\n\t\t\t\t\t")]:[_vm._v("\n\t\t\t\t\t\tCambiar Contraseña\n\t\t\t\t\t")]],2)],1):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"/login"}},[_c('span',{staticClass:"text-password",style:(("color:" + (_vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t\tVolver a Iniciar Sesión\n\t\t\t\t")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/91.7d02ddb7d935be6d7db0.js